export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12607.48a9ec93.jpg";